// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TCianApiSiteV1GetUserDataByRequestModel,
  IMappers,
  TCianApiSiteV1GetUserDataByRequestResponse,
  ICianApiSiteV1GetUserDataByRequestResponse,
} from './types';

export const defaultConfig: TCianApiSiteV1GetUserDataByRequestModel = {
  apiType: 'legacy',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/get-user-data-by-request/',
} as TCianApiSiteV1GetUserDataByRequestModel;

export function createCianApiSiteV1GetUserDataByRequestModel(): TCianApiSiteV1GetUserDataByRequestModel {
  return {
    ...defaultConfig,
  };
}

export interface ICianApiSiteV1GetUserDataByRequestOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

export async function fetchCianApiSiteV1GetUserDataByRequest<TResponse200>({
  httpApi,
  config,
  mappers,
}: ICianApiSiteV1GetUserDataByRequestOptions<TResponse200>): Promise<
  TCianApiSiteV1GetUserDataByRequestResponse | TResponse200
> {
  const { statusCode, response, headers } = await httpApi.fetch(createCianApiSiteV1GetUserDataByRequestModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICianApiSiteV1GetUserDataByRequestResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCianApiSiteV1GetUserDataByRequestResponse;
}
